import { USER_IMPRESSION_SUB_GROUP,
    USER_IMPRESSION_GROUP,
    IMPRESSION_TYPE,
    FEATURE_NAME,
    PAGE_NAME,
    PAGE_VIEW
} from '../consts';
import { WORKSPACE_LANDING_PAGE_SHOW, LANDING_PAGE_IS_SHOWN } from './bigQueryEvents';

const commonData = (data) => ({
    user: { id: data.userId }
});

const createBqWorkspacePageViewParams = (data) => ({
    ...commonData(data),
    feature: { name: FEATURE_NAME },
    type: WORKSPACE_LANDING_PAGE_SHOW,
    group: USER_IMPRESSION_GROUP,
    sub_group: USER_IMPRESSION_SUB_GROUP,
    page: { name: PAGE_NAME, ctx_id: data.pageCtxId },
    action: { type: IMPRESSION_TYPE }
});

const createLandingPageViewParams = (data) => ({
    ...commonData(data),
    type: LANDING_PAGE_IS_SHOWN,
    group: PAGE_VIEW,
    page: { name: data.pageName, ctx_id: data.pageCtxId },
    action: { type: PAGE_VIEW },
    ...(data.source && { event_source: data.source })
});

export { createBqWorkspacePageViewParams, createLandingPageViewParams };
